import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sync-inputs"
export default class extends Controller {
  static targets = ["input"];
  connect() {
    this.inputListeners = [];
    this.inputTargets.forEach((input) => {
      this.inputTargets.forEach((otherInput) => {
        if (!otherInput.value) {
          otherInput.value = input.value;
        }
      });
      const handler = () => {
        this.inputTargets.forEach((otherInput) => {
          otherInput.value = input.value;
        });
      };
      input.addEventListener("change", handler);
      this.inputListeners.push({ input, handler });
    });
  }

  disconnect() {
    this.inputListeners.forEach(({ input, handler }) => {
      input.removeEventListener("change", handler);
    });
  }
}
